/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface OTPViaEmailMethodOptions
 */
export interface OTPViaEmailMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof OTPViaEmailMethodOptions
     */
    method: FactorMethod;
}



/**
 * Check if a given object implements the OTPViaEmailMethodOptions interface.
 */
export function instanceOfOTPViaEmailMethodOptions(value: object): value is OTPViaEmailMethodOptions {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}

export function OTPViaEmailMethodOptionsFromJSON(json: any): OTPViaEmailMethodOptions {
    return OTPViaEmailMethodOptionsFromJSONTyped(json, false);
}

export function OTPViaEmailMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPViaEmailMethodOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
    };
}

export function OTPViaEmailMethodOptionsToJSON(json: any): OTPViaEmailMethodOptions {
    return OTPViaEmailMethodOptionsToJSONTyped(json, false);
}

export function OTPViaEmailMethodOptionsToJSONTyped(value?: OTPViaEmailMethodOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': FactorMethodToJSON(value['method']),
    };
}

